<template>
  <div class="page-container">
    <md-app>
      <md-app-toolbar id="top-menu" class="md-dense" md-elevation="1">
        <span id="logo" class="md-title">Integra</span>

        <div class="md-toolbar-section-end">
          <md-menu md-size="medium" md-align-trigger v-if="user">
            <md-button md-menu-trigger>
              <md-avatar v-if="user.fotoUrl" class="md-small">
                <img :src="user.fotoUrl" alt="Avatar">
              </md-avatar>
              <md-avatar v-else class="md-avatar-icon md-small">
                <md-icon>person</md-icon>
              </md-avatar>
              {{user.shortName}}
            </md-button>

            <md-menu-content>
              <md-menu-item v-on:click="logout">
                <span>Sair</span>
                <md-icon>exit_to_app</md-icon>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
      </md-app-toolbar>
      <md-app-content>
        <slot />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
  export default {
    computed: {
      user() {
        let user = null;
        if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
          user = {
            ...this.msal.user,
            profile: {}
          }

          if (this.msal.graph && this.msal.graph.profile) {
            user.profile = this.msal.graph.profile;

            if (this.msal.graph.photo) {
              user.fotoUrl = URL.createObjectURL(this.msal.graph.photo);
            }
          }

          //Split do Nome
          let nameSplited = user.name ? user.name.split(' ') : "";
          if (nameSplited.length > 2) {
            user.shortName = nameSplited[0] + ' ' + nameSplited[nameSplited.length - 1];
          }
          else
            user.shortName = user.name;
        }

        return user;
      }
    },
    methods: {
      logout() {
        this.$msal.signOut();
      }
    }
  }
</script>

<style>
  #logo {
    text-decoration: none !important;
    color: inherit !important;
  }

  .md-app {
    height: -webkit-fill-available;
  }
</style>
